import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';

import {ToastModule, ToastOptions} from 'ng6-toastr';
import {RequestsService} from './services/requests.service';

import {PERFECT_SCROLLBAR_CONFIG} from 'ngx-perfect-scrollbar';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';


import {AppConfig} from './config/app.config';
import {AppRoutingModule, routingComponenets} from './app-routing.module';
import {AppComponent} from './app.component';
import {HeaderComponent} from './source/includes/header.component';
import {FooterComponent} from './source/includes/footer.component';
import {NavComponent} from './source/includes/nav.component';
import {MenuComponent} from './source/includes/menu.component';
import {CustomOption} from './config/CustomOption';
import {SharedService} from './services/SharedService';

import {TokenInterceptor} from './services/tokenInterceptor';

import {DatePipe} from '@angular/common';

import {NgProgressModule} from '@ngx-progressbar/core';
import {NgProgressHttpClientModule} from '@ngx-progressbar/http-client';
import {jqxPanelComponent} from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxpanel';
import {jqxChartComponent} from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxchart';

import {SharedModule} from './source/shared_module/shared.module';

import {BodyComponent} from './source/includes/body.component';
import {LoginComponent, LogoutComponent} from './login/login.component';
import {ForgetComponent, ResetComponent} from './forget/forget.component';
import {DashboardComponent} from './source/dashboard.component';
import {AngularFireDatabaseModule} from '@angular/fire/database';
import {AngularFireMessagingModule} from '@angular/fire/messaging';
import {AngularFireAuthModule} from '@angular/fire/auth';
import {AngularFireModule} from '@angular/fire';
import {environment} from '../environments/environment';
import {MessagingService} from './services/messagingService';
import {ServiceWorkerModule} from '@angular/service-worker';
import {NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule} from 'ngx-ui-loader';
import { LockingComponent } from './locking/locking.component';
import { MiscsettingsComponent } from './miscsettings/miscsettings.component';
import { PosSettingsComponent } from './source/possettings/component/possettings/possettings.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

const apiBarcodeCheck = AppConfig.NT_HTTP_PROTOCOL + AppConfig.NT_HTTP_SEPARATOR + AppConfig.NT_API_ENDPOINT + 'pos/items/checkBarcode';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  'bgsColor': '#fafbfb',
  'bgsOpacity': 0.4,
  'bgsPosition': 'bottom-right',
  'bgsSize': 50,
  'bgsType': 'ball-spin-clockwise',
  'blur': 2,
  'fgsColor': '#145388',
  'fgsPosition': 'center-center',
  'fgsSize': 60,
  'fgsType': 'three-bounce',
  'gap': 24,
  'logoPosition': 'center-center',
  'logoSize': 120,
  'logoUrl': '',
  'masterLoaderId': 'master',
  'overlayBorderRadius': '0',
  'overlayColor': 'rgba(40,40,40,0.5)',
  'pbColor': '#145388',
  'pbDirection': 'ltr',
  'pbThickness': 4,
  'hasProgressBar': true,
  'text': '',
  'textColor': '#145388',
  'textPosition': 'center-center',
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    NavComponent,
    MenuComponent,
    BodyComponent,
    LoginComponent,
    ForgetComponent,
    ResetComponent,
    LogoutComponent,
    DashboardComponent,
    jqxPanelComponent,
    jqxChartComponent,
    LockingComponent,
    MiscsettingsComponent,
    PosSettingsComponent,

  ],
  imports: [
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpModule, ToastModule.forRoot(),
    // NgProgressModule,
    NgProgressModule.forRoot(),
    NgProgressHttpClientModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    ServiceWorkerModule.register('/ngsw-worker.js', {enabled: environment.production}),
    // NgMultiSelectDropDownModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({showForeground: true, exclude: [apiBarcodeCheck]}),
  ],
  providers: [SharedService, MessagingService, DatePipe, RequestsService, AppConfig, {
    provide: ToastOptions,
    useClass: CustomOption
  },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }, {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }

  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
